
import { Component, Vue, Watch } from "vue-property-decorator";
import { ScanforGetOnModule } from "@/store/modules/store_scanforgeton";
import { SystemConfigModule } from "@/store/modules/store_systemconfig";

@Component({
  name: "Form2",
  props: ["formdata"],
  watch: {
    formdata: {
      handler(newone, oldone) {
        console.log("从上车主界面传来的数据");
        console.log(oldone);
        console.log("从上车主界面传来的数据");
        console.log(newone);
      },
      immediate: true,
    },
  },
})
export default class extends Vue {
  get IsSumWeightFlag() {
    return ScanforGetOnModule.checked_IsSumWeight;
  }
  set IsSumWeightFlag(state) {
    ScanforGetOnModule.IsSumWeightChangeState(state);
  }
  get IsOverTimeCarFlag() {
    return ScanforGetOnModule.checked_IsOverTimeCar;
  }
  set IsOverTimeCarFlag(state) {
    ScanforGetOnModule.IsOverTimeCarChangeState(state);
  }
  get AutoCreateCarCodeFlag() {
    return ScanforGetOnModule.checked_AutoCreateCarCode;
  }
  set AutoCreateCarCodeFlag(state) {
    console.log("state");
    console.log(state);
    ScanforGetOnModule.AutoCreateCarCodeChangeState(state);
  }
  get NeedWeightFlag() {
    return ScanforGetOnModule.checked_NeedWeight;
  }
  set NeedWeightFlag(state) {
    ScanforGetOnModule.NeedWeightChangeState(state);
  }
  mounted() {
    this.InitConfig();
    ScanforGetOnModule.NeedWeightChangeState(true);
  }
  private AutoCreateCarCodeChangeFunc(isChecked) {
    this.$emit("auto-create-car-code-change", isChecked);
  }
  public InitConfig() {
    //判断是否是出港
    if (SystemConfigModule.globalData.InOutFlag == "2") {
      ScanforGetOnModule.IsSumWeightChangeState(true);
    } else {
      ScanforGetOnModule.IsSumWeightChangeState(false);
    }
  }
  private AutoCreateCarCodeShow: Boolean = false;
}
